import { gql } from '@apollo/client';

export const LOCATIONS = gql`
  query location($order_by: [location_order_by!]) {
    location(order_by: $order_by) {
      color
      id
      name
    }
  }
`;

export const LOCATIONS_FOR_TIMETABLE = gql`
  query locations_for_timetable($order_by: [location_order_by!]) {
    location(order_by: $order_by) {
      color
      id
      name
    }
  }
`;
